module.exports = __webpack_public_path__ + "img/loading.f3cf19e0.gif";